// What a dashboard widget shows while its data is not there: loading, an empty state when the
// host does not serve the endpoint (404: an ocs-api from before the dashboard endpoints), and
// an empty state that names the error otherwise. A widget never breaks the page.
import type { UseQueryResult } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { ApiError } from "../api/queries";
import { EmptyState, Loading } from "../ui/states";

export function QueryState<T>({
  query,
  icon,
  empty,
  children,
}: {
  query: UseQueryResult<T, Error>;
  icon: ReactNode;
  /** The widget's words for an endpoint that is missing or failed. */
  empty: { title: string; missing: string; failed: (error: string) => string };
  children: (data: T) => ReactNode;
}) {
  if (query.isPending) return <Loading />;
  if (query.isError) {
    const missing = query.error instanceof ApiError && query.error.status === 404;
    return (
      <EmptyState compact icon={icon} title={empty.title}>
        {missing ? empty.missing : empty.failed(query.error.message)}
      </EmptyState>
    );
  }
  return <>{children(query.data)}</>;
}
